import { collection, getDocs } from "firebase/firestore";
import logger from "logging/logger";
import { firestore } from "services/firebaseService/firebaseConfig";

export const LOBBY_COL = "UsersInLobby";

export const USERS_DOC = "users";

export const COUNT = "count";

export const getLobbyDoc = (eventId: string) =>
  collection(firestore, `${LOBBY_COL}/${eventId}/${USERS_DOC}`);

export const getWaitingUsers = async (eventId: string): Promise<number> => {
  const usersSnapshot = await getDocs(getLobbyDoc(eventId));
  const users = usersSnapshot.docs;

  const waitingUsers = users.filter((user) => user.get("state") === "PENDING");

  logger.info(
    `[getWaitingUsers] for event: ${eventId}, count=${waitingUsers.length}`,
  );

  return waitingUsers.length;
};
